export default "__VITE_ASSET__C1X$S5sh__"